import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { X, Calculator, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useCompany } from "@/contexts/BusinessSettingsContext";
import { useFeatureFlags } from "@/hooks/useFeatureFlags";

const HIDDEN_PREFIXES = [
  "/admin",
  "/dashboard",
  "/login",
  "/reset-password",
  "/payment-success",
  "/quote",
  "/book",
  "/schedule",
];

export function QuotePopup() {
  const location = useLocation();
  const co = useCompany();
  const flags = useFeatureFlags();
  const [open, setOpen] = useState(true);

  const blocked = HIDDEN_PREFIXES.some((p) => location.pathname.startsWith(p));

  const dismiss = () => setOpen(false);

  // The CTA remains mounted across public-page navigation, but privacy choice
  // always has priority when the cookie banner is enabled.
  const [consentPending, setConsentPending] = useState(true);
  useEffect(() => {
    if (!flags.loaded) return;
    if (!flags.cookie_consent) {
      setConsentPending(false);
      return;
    }
    const check = () => {
      try {
        setConsentPending(!localStorage.getItem("altar-cookie-consent"));
      } catch {
        setConsentPending(false);
      }
    };
    check();
    const id = setInterval(check, 1000);
    return () => clearInterval(id);
  }, [flags.loaded, flags.cookie_consent]);

  if (blocked || !open || consentPending) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[100] animate-in fade-in slide-in-from-bottom-2">
      <div className="relative flex items-center gap-2 rounded-full border bg-card/95 backdrop-blur px-2 py-2 pr-8 shadow-lg">
        <Button
          asChild
          size="sm"
          className="rounded-full h-8 px-3 text-xs bg-accent text-accent-foreground hover:bg-primary hover:text-primary-foreground transition-colors"
        >
          <Link to="/quote">
            <Calculator className="h-3.5 w-3.5 mr-1.5" />
            Free Estimate
          </Link>
        </Button>
        <Button
          asChild
          size="sm"
          className="rounded-full h-8 px-3 text-xs bg-primary text-primary-foreground hover:bg-accent hover:text-accent-foreground transition-colors"
        >
          <a href={`tel:${co.companyPhone.replace(/\D/g, "")}`}>
            <Phone className="h-3.5 w-3.5 mr-1.5" />
            {co.companyPhone}
          </a>
        </Button>
        <button
          onClick={dismiss}
          aria-label="Close"
          className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
}

